module.exports = __webpack_public_path__ + "img/DNADamage-MELA_SpatialResearch.f8a6ee97.png";